import React from 'react';
import { Landing } from './pages/Landing';
type AppProps = {
  showTestimonials?: boolean;
  showStickyBar?: boolean;
};
export function App({
  showTestimonials = true,
  showStickyBar = true
}: AppProps) {
  return <Landing showTestimonials={showTestimonials} showStickyBar={showStickyBar} data-id="element-0" data-mp="3k9umjipz6cfr" />;
}